<ng-container *ngIf="anfrage != null">
    <blazor-anfrage-sharing id="blazor-anfrage-sharing" [anfrageid]="anfrage.id" [scope]="anfrage.objektTyp" [usertoken]="userToken()"></blazor-anfrage-sharing>
</ng-container>